import { agentTraining } from '@/content/site';
import './AgentTrainingChatMock.css';

export function AgentTrainingChatMock() {
  const { chat } = agentTraining;

  return (
    <div className="training-mock glass-card" aria-hidden>
      <div className="training-mock__chrome">
        <span className="training-mock__dots" aria-hidden>
          <i />
          <i />
          <i />
        </span>
        <span className="training-mock__title">{chat.windowTitle}</span>
        <span className="training-mock__badge">{chat.status}</span>
      </div>

      <div className="training-mock__thread">
        {chat.messages.map((msg, i) => (
          <div
            key={i}
            className={
              msg.role === 'visitor'
                ? 'training-mock__row training-mock__row--visitor'
                : 'training-mock__row training-mock__row--agent'
            }
          >
            <div className="training-mock__bubble">{msg.text}</div>
            {'highlight' in msg && msg.highlight === 'feedback' ? (
              <div className="training-mock__feedback">
                <div className="training-mock__feedback-btns">
                  <button type="button" className="training-mock__thumb training-mock__thumb--up" tabIndex={-1}>
                    👍
                  </button>
                  <button type="button" className="training-mock__thumb training-mock__thumb--down" tabIndex={-1}>
                    👎
                  </button>
                </div>
                <div className="training-mock__callouts">
                  <span className="training-mock__callout training-mock__callout--up">{chat.calloutUp}</span>
                  <span className="training-mock__callout training-mock__callout--down">{chat.calloutDown}</span>
                </div>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
